const baseURL = "/v1/AvaliacaoFormacao";

const service = {
    methods: {
        $buscarAvaliacaoFormacao(params) {
            return this.$api().get(`${baseURL}`, params);
        },
        $buscarTiposAvaliacaoFormacao(params) {
            return this.$api().get(`${baseURL}/TipoAvaliacao`, params);
        },
        $buscarTiposRespostaAvaliacaoFormacao(params) {
            return this.$api().get(`${baseURL}/TipoResposta`, params);
        },
        $visualizarAvaliacaoFormacao({ params, id }) {
            return this.$api().get(`${baseURL}/${id}`, params);
        },
        $cadastrarAvaliacaoFormacao(body) {
            return this.$api().post(`${baseURL}`, body);
        },
        $editarAvaliacaoFormacao(body, id) {
            return this.$api().put(`${baseURL}/${id}`, body);
        },
        $inativarAtivarAvaliacaoFormacao(id) {
            return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
        },
        $excluirAvaliacaoFormacao(id) {
            return this.$api().delete(`${baseURL}/${id}`);
        }
    },
};

export default service;